export const PROJECT_NAME = 'MIND UI';

export const TABLE_DEFAULTS = {
  PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50],
} as const;

export const FIELD_VALIDATORS = {
  NAME_MAX_LENGTH: 32,
  DESCRIPTION_MAX_LENGTH: 255,
  MARKER_TEMPLATE_MAX_LENGTH: 160,
  PARTICIPANT_THRESHOLD_MIN: 0,
  PARTICIPANT_THRESHOLD_MAX: 1000,
} as const;

export const TOOLTIP_SHOW_DELAY = 1000;

export const STAFF_MONITOR_MAX_PARTICIPANT_COUNT = 6;

export const MARKER_TEMPLATES_MAX_COUNT = 9;

export const CHAR_CODES = {
  SPACE: 32,
  ENTER: 69,
} as const;
